import { render, staticRenderFns } from "./BatchJobHistory.vue?vue&type=template&id=62f306fb&"
import script from "./BatchJobHistory.vue?vue&type=script&lang=js&"
export * from "./BatchJobHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports